import { createAction } from "redux-actions";
import { START } from "../common";

export const INIT_ENTITY = "INIT_ENTITY";
export const FETCH_ENTITY = "FETCH_ENTITY";

export const initEntityAction = createAction(INIT_ENTITY);
export const fetchEntityAction = createAction(FETCH_ENTITY + START);
